import {getTimestampNow} from "../../../util/Util";

export const VaprDeviceOverviewReducer = (state, action) => {
    switch(action.type) {
        case "RECEIVE_DATA":
            return {...state, ...action.data, loadingOverview: false, timestamp: getTimestampNow()}
        case "SORT_DATA":
            return {...state, sortPref: action.data}
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/components/devicemanagement/vaprdevice/reducer/VaprDeviceOverviewReducer.js